export default __webpack_public_path__ + "static/media/help.a2ec4562.svg";